'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _selectorUtils = require('./selectorUtils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// A "store" used on React's context so that multiple Checker HOCs in the component tree work together
// Following the guidelines in https://medium.com/@mweststrate/how-to-safely-use-react-context-b7e343eff076
// so that the context is merely a DI delivery mechanism and is never updated (working around some of the
// typical context issues)
var CheckerStore = function () {
  function CheckerStore() {
    _classCallCheck(this, CheckerStore);

    // This is a hack so we can test how many times a CheckerStore is created.
    this.setupStore();
  }

  _createClass(CheckerStore, [{
    key: 'setupStore',
    value: function setupStore() {
      this.checkOnChange = undefined;
      this.selectors = (0, _selectorUtils.normalizeSelectors)();
      this.customRouteName = undefined;
    }
  }, {
    key: 'getCombinedSelectors',
    value: function getCombinedSelectors() {
      return this.selectors;
    }
  }, {
    key: 'hasAnyComponentClaimedLocationChange',
    value: function hasAnyComponentClaimedLocationChange() {
      return this.checkOnChange === true;
    }
  }, {
    key: 'ensureSetOnceOrAlwaysSame',
    value: function ensureSetOnceOrAlwaysSame(key, value) {
      if (this[key] !== undefined && this[key] !== value) {
        // eslint-disable-next-line no-console
        console.error('Multiple checker HOCs cannot supply different values of ' + key + ', ' + this[key] + ' && ' + value + ' supplied.');
        return;
      }

      this[key] = value;
    }
  }, {
    key: 'mergeInNewSelectors',
    value: function mergeInNewSelectors(selectors) {
      var _this = this;

      var _normalizeSelectors = (0, _selectorUtils.normalizeSelectors)(selectors),
          success = _normalizeSelectors.success,
          error = _normalizeSelectors.error;

      Object.keys(success).forEach(function (selectorKey) {
        var selectorValue = success[selectorKey];

        if (_this.selectors.success[selectorKey]) {
          // eslint-disable-next-line no-console
          console.error('Duplicate success selector key (' + selectorKey + ') from multiple Checkers in same component tree not allowed. Use a unique name for each selector key.', 'Discarding check for ' + selectorValue);
          return;
        }
        _this.selectors.success[selectorKey] = selectorValue;
      });

      Object.keys(error).forEach(function (selectorKey) {
        var selectorValue = error[selectorKey];

        if (_this.selectors.error[selectorKey]) {
          // eslint-disable-next-line no-console
          console.error('Duplicate error selector key (' + selectorKey + ') from multiple Checkers in same component tree not allowed. Use a unique name for each selector key.', 'Discarding check for ' + selectorValue);
          return;
        }
        _this.selectors.error[selectorKey] = selectorValue;
      });
    }
  }, {
    key: 'addMoreChecks',
    value: function addMoreChecks(_ref) {
      var checkOnChange = _ref.checkOnChange,
          selectors = _ref.selectors;

      this.ensureSetOnceOrAlwaysSame('checkOnChange', checkOnChange);
      this.mergeInNewSelectors(selectors);
    }
  }, {
    key: 'removeExistingChecks',
    value: function removeExistingChecks(selectors) {
      var _this2 = this;

      var _normalizeSelectors2 = (0, _selectorUtils.normalizeSelectors)(selectors),
          success = _normalizeSelectors2.success,
          error = _normalizeSelectors2.error;

      Object.keys(success).forEach(function (selectorKey) {
        if (_this2.selectors.success[selectorKey] === undefined) {
          throw new Error('Trying to remove success check ' + selectorKey + ', but it didn\'t already exist?');
        }
        delete _this2.selectors.success[selectorKey];
      });

      Object.keys(error).forEach(function (selectorKey) {
        if (_this2.selectors.error[selectorKey] === undefined) {
          throw new Error('Trying to remove error check ' + selectorKey + ', but it didn\'t already exist?');
        }
        delete _this2.selectors.error[selectorKey];
      });
    }
  }, {
    key: 'hasCustomRouteName',
    value: function hasCustomRouteName() {
      return !!this.getCustomRouteName();
    }
  }, {
    key: 'getCustomRouteName',
    value: function getCustomRouteName() {
      return this.customRouteName;
    }
  }, {
    key: 'setCustomRouteName',
    value: function setCustomRouteName(customRouteName) {
      this.customRouteName = customRouteName;
    }
  }]);

  return CheckerStore;
}();

exports.default = CheckerStore;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-7.24/js/CheckerStore.js
// module id = 267
// module chunks = 0